import React from 'react'
import './v3-analytics-routes.css'

interface V3AnalyticsRouteShellProps {
  children: React.ReactNode
}

export default function V3AnalyticsRouteShell({ children }: V3AnalyticsRouteShellProps) {
  return (
    <div className="v3-analytics-route py-6">
      <div className="mx-auto w-[95%] min-w-0">
        <div className="v3-analytics-route__content min-w-0">
          {children}
        </div>
      </div>
    </div>
  )
}

